<template>
    <div class="one-bd clearfix">
        <router-link to="/materialCenter" exact>全网热文</router-link>
        <router-link to="/materialCenter/rectifyArticle" v-if="$parent.$parent.vipInfo.level === 20">矩阵文章</router-link>
        <router-link to="/materialCenter/myCollect">我的收藏</router-link>
        <router-link to="/materialCenter/myMaterial">我的素材</router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {
           
        }
    },
    mounted() {
		let that = this;
    },
    created() {
		
    },
    methods: {
       
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/materialCenter/matrixMenu.vue